import { Component, OnInit ,HostListener} from '@angular/core';

import { RestapiService } from '../../services/restapi.service';
import { RoutingService } from '../../services/routing.service';
import { SeoService } from 'src/app/services/seo.service';
import { NgwWowService } from 'ngx-wow';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public cont: any = {};
  public slides: any;
  public blog: any;

  public car = {
    current: 0,
    older: -1,
    anim: false,
  }

  constructor(
    public seo: SeoService,
    public api: RestapiService,
    public route: RoutingService,
    public wowService: NgwWowService
  ) { this.loadData(); }

  ngOnInit(): void {

    //    WowServ.init()
  }
  @HostListener('window:scroll', ['$event'])
    track(event) {
        console.debug("Scroll Event", event);
    }
  loadData() {
    this.wowService.init();
    this.api.getdata('webhomecarousel', { per_page: 1000 })
      .subscribe(res => {
        console.log('res webhomecarousel', res);
        if (res.status === true) {
          this.slides = res.result.data;
          this.startCarousel();
        }
      });

    this.api.getdata('websection', { per_page: 10, filters: { webroute_id: { value: 1 } } })
      .subscribe(res => {
        console.log('res websection home', res);
        if (res.status === true) {
          this.cont.section = { websectiondata: [] }
          let dir = false;
          res.result.data.forEach(el => {
            let customWidget = {
              title: el.title.es,
              content: el.tag,
              image: el.image,
              type: dir === true ? 11 : 12,
              websectiondata: el.websectiondata
            }
            dir = !dir;
            this.cont.section.websectiondata.push(customWidget)
          });
        }
      })


    this.api.getdata('websection', { per_page: 6, filters: { webroute_id: { value: 7 } } })
      .subscribe(res => {
        console.log('res websection proyecto en imagenes', res);
        if (res.status === true) {
          this.blog = res.result.data;
        }
      })
  }


  startCarousel() {
   /**/  setInterval(() => {
      this.changeSlide('next', 3);
    }, 8000);
  }

  changeSlide(value, limit) {
    this.car.older = this.car.current;
    this.car.anim = true;
    setTimeout(() => {
      this.car.anim = false;
    }, 3500);
    //setTimeout(() => {
    switch (value) {
      case 'next':
        (this.car.current + 1 >= limit) ? this.car.current = 0 : this.car.current++;
        break;
      case 'prev':
        (this.car.current - 1 <= 0) ? this.car.current = limit - 1 : this.car.current--;
        break;
      default:
        this.car.current = value;
        break;
    }
    //  }, 1500);


  }

}
